import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  width: 100%;
  height: calc(100vh - 190px);
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const Spinner = styled.svg`
  animation: rotate 2s linear infinite;
  width: 85px;
  height: 85px;
  margin: auto;
  
  & .path {
    stroke: ${C.LIGHT_GRAY};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
  
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;